import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type DepartmentFragment = { id: string, name: string };


export type DepartmentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const DepartmentFragmentDoc = /*#__PURE__*/ gql`
    fragment Department on DepartmentType {
  id
  name
}
    `;